import React from "react";

function SvgResume(props) {
    return (
        <svg
            id="resume_svg__Layer_1"
            x={0}
            y={0}
            viewBox="0 0 495 495"
            xmlSpace="preserve"
            height="5vh"
            {...props}
        >
            <style>
                {
                    ".resume_svg__st1,.resume_svg__st4{fill:#fff}.resume_svg__st4{stroke:#fff;stroke-width:10;stroke-miterlimit:10}"
                }
            </style>
            <path fill="#fff" d="M247.5 0v40H455v415H247.5v40H495V0z" />
            <path
                className="resume_svg__st1"
                d="M40 455V40h207.5V0H0v495h247.5v-40z"
            />
            <g id="resume_svg__zA4vNO_1_">
                <path
                    className="resume_svg__st1"
                    d="M209.3 160.3c-24-14.7-48.7-14.9-72.6-.1-21 13.1-31.1 33-31.8 57.8h135.8c.7-18.2-7.9-43.2-31.4-57.7zm-26 36.5c-2.9 4-5.9 7.9-8.9 11.8-1.1 1.4-2.2 1.4-3.2 0-3-3.9-6-7.8-8.8-11.8-.4-.6-.6-1.6-.4-2.3 2.7-9.4 5.5-18.8 8.3-28.1.5-1.6.4-2.9-.8-4.3-1.3-1.4-2.3-3-3.4-4.6-.3-.6-.6-1.5-.3-2s1.2-.9 1.8-.9c1.7-.1 3.5 0 5.2 0h5.2c1.8.1 2.5 1.3 1.5 2.8-1.2 1.8-2.5 3.5-3.8 5.2-.8 1-1 1.9-.6 3.2 2.9 9.6 5.7 19.2 8.5 28.8.3.5.2 1.6-.3 2.2z"
                />
                <path
                    className="resume_svg__st1"
                    d="M211.4 107.2c.2 21.9-17.5 38.9-38.7 38.8-20.4 0-38.1-16.4-38.4-38.1-.3-21.9 17.6-39 38.5-39 20.5 0 38.5 16.2 38.6 38.3z"
                />
            </g>
            <text
                transform="translate(283.752 196.41)"
                className="resume_svg__st1"
                fontSize={126.366}
                fontFamily="MyriadPro-Regular" color="#fff"
            >
                {"cv"}
            </text>
            <path
                className="resume_svg__st4"
                d="M94.5 263h306M94.5 319.3h306M94.5 375.7h306M94.5 432h220"
            />
        </svg>
    );
}

export default SvgResume;



// WEBPACK FOOTER //
// ./src/images/svg/SvgResume.jsx